/*****************************************
 * DISTINCT INTERFACES START
 * **************************************
 */

/**
 * The operation item interface
 */
export interface IOperationItem {
  label: OperationName;
  value: Operation;
}

/**
 * The get all field name response interface
 */
export interface IFieldName {
  nonEditableFieldMarkId: number;
  nonEditableFieldName: string;
  operation: Operation;
  operationName: OperationName;
}

/**
 * The get all non editable field response interface
 */
export interface INonEditableField {
  developmentNameId: number;
  developmentName: string;
  fieldNameList: IFieldName[];
}

/**
 * The add non editable field mark request interface
 */
export interface IAddtNonEditableFieldMark {
  nonEditableFieldMarkId: number;
  operation: Operation;
  operationName: string;
  nonEditableFieldName: string;
}

/*****************************************
 * DISTINCT INTERFACES END
 * **************************************
 */

/*****************************************
 * PAYLOAD INTERFACES
 * **************************************
 */

/**
 * The get all non editable field mark request body
 */
export interface IGetNonEditableFieldMarkRequestBody {
  developmentNameId: number;
}

/**
 * The get all non editable field response body
 */
export type IGetNonEditableFieldMarksResponseBody = INonEditableField;

/**
 * The add non editable field mark request body interface
 */
export type IAddtNonEditableFieldMarkRequestBody = IAddtNonEditableFieldMark[];

/**
 * The delete non editable field mark request body interface
 */
export interface IDeleteNonEditableFieldMarkRequestBody {
  nonEditableFieldMarkId: number;
}

/**
 * The operation list interface
 */
export type IOperationList = IOperationItem[];

/**
 * The operation enum
 */
export enum Operation {
  INSERT = 1,
  UPDATE = 2,
}

/**
 * The operation name enum
 */
export enum OperationName {
  INSERT = 'Insert',
  UPDATE = 'Update',
}
